import React from 'react';
import { Background } from 'styles/styled-components/section';
import SearchSelectPlatformRow from 'components/search/SearchSelectPlatformRow';
import SearchInputRow from 'components/search/SearchInputRow';
import useCommonStore from 'store/useCommonStore';
import SearchInputModal from 'components/search/SearchInputModal';
import SearchStateRow from 'components/search/SearchStateRow';
import SearchResult from 'components/search/SearchResult';
import useCallbackRef from 'hooks/useCallbackRef';

const Search = () => {
	const { search_modal } = useCommonStore();

	const [bg_dom, bgRef] = useCallbackRef();

	return (
		<>
			<Background ref={bgRef}>
				<SearchInputRow bg_dom={bg_dom} />
				<SearchSelectPlatformRow />
				<SearchStateRow />

				<SearchResult />
			</Background>
			{search_modal && <SearchInputModal />}
		</>
	);
};

export default Search;
